import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scroll the window to the top whenever the pathname changes.
 * Respects hash links (e.g. /about#members) — if a hash is present the
 * per-page scroll-to-anchor logic keeps working.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return; // let per-page hash handlers control the scroll
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);
  return null;
};

export default ScrollToTop;
